import * as actionTypes from './actionTypes';

export const setHotelAdult = (value, id) => {
    return {
        type: actionTypes.SET_HOTEL_ADULT,
        val: value,
        id: id
    }
}

export const setHotelChild = (value, id) => {
    return {
        type: actionTypes.SET_HOTEL_CHILD,
        val: value,
        id: id
    }
}

export const setChildAge = (value, id, roomIndex) => {
    return {
        type: actionTypes.SET_CHILD_AGE,
        val: value,
        id: id,
        roomIndex: roomIndex
    }
}

export const clickHotelAdult = () => {
    return {
        type: actionTypes.CLICK_HOTEL_ADULT
    }
}

export const clickHotelChild = () => {
    return {
        type: actionTypes.CLICK_HOTEL_CHILD
    }
}

export const addHotelRoom = (value) => {
    return {
        type: actionTypes.ADD_HOTEL_ROOM,
        val: value
    }
}

export const removeHotelRoom = (value) => {
    return {
        type: actionTypes.REMOVE_HOTEL_ROOM,
        val: value
    }
}

export const setActiveRoom = (value) => {
    return {
        type: actionTypes.SET_ACTIVE_ROOM,
        val: value
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/hotelTravellers.js